import {MutationTree} from "vuex";
import {PartnersConnectionsState} from "@/store/settings/partners_connections/types";

export const mutations: MutationTree<PartnersConnectionsState> = {
  setPartnersConnections(state, data) {
    state.partnersConnections = data;
  },
};